import { Navigate, Route, Routes } from 'react-router-dom';

import MonitoringLayout from 'src/features/monitoring/components/MonitoringLayout';
import MonitoringDevices from 'src/features/routes/monitoring/MonitoringDevices';
import MonitoringPayStations from 'src/features/routes/monitoring/MonitoringPayStations';
import MonitoringGateways from 'src/features/routes/monitoring/MonitoringGateways';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { PERMISSION } from 'src/features/auth';
import { PATH } from 'src/features/navigation/utils/constants';

export default function MonitoringRoutes() {
    const accessPayStations = useHasPermissions([PERMISSION.ACCESS_PAY_STATIONS_MONITORING]);
    const accessDevices = useHasPermissions([PERMISSION.ACCESS_COMPONENTS_HEALTH]);
    const accessGateways = useHasPermissions([PERMISSION.ACCESS_GATEWAYS_MONITORING]);

    const defaultRoutePath = (() => {
        if (accessGateways) return `/${PATH.MONITORING}/gateways`;
        if (accessPayStations) return `/${PATH.MONITORING}/pay-station`;
        if (accessDevices) return `/${PATH.MONITORING}/devices`;

        return '/no-access';
    })();

    return (
        <Routes>
            <Route element={<MonitoringLayout />}>
                <Route index element={<Navigate to={defaultRoutePath} replace />} />
                {accessGateways && <Route path="gateways" element={<MonitoringGateways />} />}
                {accessPayStations && <Route path="pay-station" element={<MonitoringPayStations />} />}
                {accessDevices && <Route path="devices" element={<MonitoringDevices />} />}
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    );
}
